<div class="ni-page-wrap search-primary-navigation" *ngIf="!shouldHide">
  <div class="nisearch-nav-scroll">
    <ul id="nisearch-nav" class="nav vertical-align-middle">
      <ng-container *ngIf="searchResult.searchResultList?.length || searchResult.narrowByFacets?.clearAllFacetValue">
        <li
          class="nav-item"
          data-url="${node.getData.getUrl}"
          *ngFor="let facet of facets"
          (mouseenter)="onMouseEnter()"
          (mouseleave)="onMouseLeave()"
          (click)="selectFacet(facet)"
        >
          <app-search-primary-navigation-item
            [isHovered]="eventSubject.asObservable()"
            [facetItem]="facet"
          ></app-search-primary-navigation-item>
        </li>
      </ng-container>
    </ul>
  </div>
</div>
